<script>
// import simplebar from "simplebar-vue";
import i18n from "../i18n";
import store from "@/state/store";
import InstitutionalLogosBanner from "@/components/institutional-logos-banner.vue";
import AppBrandLogo from "@/components/AppBrandLogo.vue";

export default {
  components: {
    InstitutionalLogosBanner,
    AppBrandLogo,
  },
  data() {
    return {
      languages: [
        {
          flag: require("@/assets/images/flags/us.jpg"),
          language: "en",
          title: "English",
        },
        {
          flag: require("@/assets/images/flags/french.jpg"),
          language: "fr",
          title: "French",
        },
        {
          flag: require("@/assets/images/flags/spain.jpg"),
          language: "es",
          title: "spanish",
        },
        {
          flag: require("@/assets/images/flags/chaina.png"),
          language: "zh",
          title: "Chinese",
        },
        {
          flag: require("@/assets/images/flags/arabic.png"),
          language: "ar",
          title: "Arabic",
        },
      ],
      current_language: "es",
    };
  },
  methods: {
    toggleMenu() {
      this.$parent.toggleMenu();
    },
    initFullScreen() {
      document.body.classList.toggle("fullscreen-enable");
      if (
        !document.fullscreenElement &&
        /* alternative standard method */ !document.mozFullScreenElement &&
        !document.webkitFullscreenElement
      ) {
        // current working methods
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(
            Element.ALLOW_KEYBOARD_INPUT
          );
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    },
    toggleRightSidebar() {
      this.$parent.toggleRightSidebar();
    },
    setLanguage(locale) {
      i18n.locale = locale;
      this.current_language = i18n.locale;
    },
  },
  computed: {
    userName() {
      return store.getters["auth/nameUser"];
    },
  },
};
</script>

<template>
  <header id="page-topbar">
    <div class="navbar-header">
      <div class="d-flex align-items-center" style="gap: 1rem;">
        <!-- Menu Button -->
        <button
          @click="toggleMenu"
          type="button"
          class="btn btn-sm px-3 font-size-24 header-item waves-effect menu-toggle-btn"
          id="vertical-menu-btn"
          style="border-radius: 8px; transition: all 0.3s ease;"
        >
          <i class="ri-menu-2-line align-middle"></i>
        </button>

        <!-- LOGO -->
        <div class="navbar-brand-box" style="text-align: center; min-width: 200px;">
          <a href="/" class="logo">
            <span class="logo-sm">
              <AppBrandLogo size="sm" style="border-radius: 6px;" />
            </span>
            <span class="logo-lg text-center">
              <AppBrandLogo size="lg" style="border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.1);" />
            </span>
          </a>
        </div>

      </div>

      <div class="topbar-logos-container">
        <InstitutionalLogosBanner variant="compact" />
      </div>

      <div class="d-flex align-items-center" style="gap: 0.75rem;">
        <b-dropdown
          right
          variant="black"
          toggle-class="header-item"
          class="d-inline-block user-dropdown"
        >
          <template v-slot:button-content>
            <div class="d-flex align-items-center" style="gap: 0.5rem; padding: 0.5rem 1rem; border-radius: 8px; transition: all 0.3s ease;">
              <div class="header-profile-user rounded-circle d-flex align-items-center justify-content-center" style="width: 40px; height: 40px; background: rgba(110, 166, 55, 0.15); color: #6ea637; font-weight: 600;">
                {{ userName ? userName.charAt(0).toUpperCase() : 'U' }}
              </div>
              <span class="d-none d-xl-inline-block" style="font-weight: 500; color: #2c3e50;">{{ userName }}</span>
              <i class="mdi mdi-chevron-down d-none d-xl-inline-block" style="color: #2c3e50;"></i>
            </div>
          </template>
          <!-- item-->
          <!-- <a class="dropdown-item" href="#">
            <i class="ri-user-line align-middle mr-1"></i>
            {{ $t('navbar.dropdown.kevin.list.profile') }}
          </a>
          <a class="dropdown-item" href="#">
            <i class="ri-wallet-2-line align-middle mr-1"></i>
            {{ $t('navbar.dropdown.kevin.list.mywallet') }}
          </a>
          <a class="dropdown-item d-block" href="#">
            <span class="badge badge-success float-right mt-1">11</span>
            <i class="ri-settings-2-line align-middle mr-1"></i>
            {{ $t('navbar.dropdown.kevin.list.settings') }}
          </a>
          <a class="dropdown-item" href="#">
            <i class="ri-lock-unlock-line align-middle mr-1"></i>
            {{ $t('navbar.dropdown.kevin.list.lockscreen') }}
          </a>
          <div class="dropdown-divider"></div> -->
          <router-link :to="'/logout'" class="dropdown-item text-danger">
            <i class="ri-shut-down-line align-middle mr-1 text-danger"></i>
            {{ $t("navbar.dropdown.kevin.list.logout") }}
          </router-link>
        </b-dropdown>

        <!-- <div class="dropdown d-inline-block">
          <button
            type="button"
            class="btn header-item noti-icon right-bar-toggle waves-effect toggle-right"
            @click="toggleRightSidebar"
          >
            <i class="ri-settings-2-line toggle-right"></i>
          </button>
        </div> -->
      </div>
    </div>
  </header>
</template>

<style lang="scss" scoped>
.notify-item {
  .active {
    color: #16181b;
    background-color: #f8f9fa;
  }
}

.menu-toggle-btn {
  color: #6ea637 !important;
  
  i {
    color: #6ea637;
  }
  
  &:hover {
    background-color: rgba(110, 166, 55, 0.1) !important;
    color: #558b2f !important;
    
    i {
      color: #558b2f;
    }
  }
}

.topbar-logos-container {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.5rem 1.5rem;
  min-width: 0;
  overflow: hidden;
  height: 100%;
  max-width: 100%;

  // Desktop grande: visible y centrado con espacio adecuado
  @media (min-width: 1200px) {
    display: flex;
    padding: 0 2rem;
  }

  // Desktop: visible y centrado
  @media (min-width: 992px) and (max-width: 1199px) {
    display: flex;
    padding: 0 1.5rem;
  }

  // Tablet: visible pero más compacto
  @media (max-width: 991px) and (min-width: 768px) {
    display: flex;
    padding: 0 1rem;
  }

  // Mobile: oculto para mantener espacio limpio y mejor UX
  @media (max-width: 767px) {
    display: none;
  }
}

// Asegurar que el navbar-header mantenga la distribución correcta
:deep(.navbar-header) {
  position: relative;
  
  // Ajustes para mobile
  @media (max-width: 767px) {
    .topbar-logos-container {
      display: none !important;
    }
  }
}

</style>
